import { render, staticRenderFns } from "./Lszjj.vue?vue&type=template&id=0b4ce549&scoped=true&"
import script from "./Lszjj.vue?vue&type=script&lang=js&"
export * from "./Lszjj.vue?vue&type=script&lang=js&"
import style0 from "./Lszjj.vue?vue&type=style&index=0&id=0b4ce549&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4ce549",
  null
  
)

export default component.exports